import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class LoanAccountService {
	private readonly uri: string = `${environment.DO_URL}/v2`;

	constructor(private readonly http: HttpClient) { }

	// Application CRUD operations
	getLoanAccounts(input_date: string): Observable<any> {
		return this.http.get(`${this.uri}/loan-accounts/${input_date}`);
	}

	getDailyTarget(input_date: string): Observable<any> {
		return this.http.get(`${this.uri}/loan-accounts/daily_target/${input_date}`);
	}

	updateLoanAccount(data: any): Observable<any> {
		return this.http.put(`${this.uri}/loan-account/${data.cifnumber}`, data);
	}

	updateLoanAccountException(data: any): Observable<any> {
		return this.http.put(`${this.uri}/loan-account/exception/${data.cifnumber}`, data);
	}

	getExceptions(input_year: number, input_month: number): Observable<any> {
		return this.http.get(`${this.uri}/loan-accounts/exceptions/${input_year}/${input_month}`);
	}

	getFundedDeals(employeeID: number): Observable<any> {
		return this.http.get(`${this.uri}/loan-accounts/sales-agent/${employeeID}`);
	}

	getMOMLoanAccounts(input_year: number, input_month: number): Observable<any> {
		return this.http.get(`${this.uri}/mom-loan-accounts/${input_year}/${input_month}`);
	}

	updateMOMLoanAccount(data: any): Observable<any> {
		return this.http.put(`${this.uri}/loan-account-mom/${data.input_date}`, data);
	}
}
